import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { appInstanceApi } from "@workspace/app-instance/api";

import { firstLocationId } from "@/lib/first-location";
import { NoLocations } from "@/components/no-locations";
import { PageLoadingFull } from "@/components/page-loading";

export const Route = createFileRoute("/app/$tenant/")({
	component: RouteComponent,
	pendingComponent: PageLoadingFull,
	beforeLoad: async ({
		context: {
			queryClient,
			tenants: { setTenant },
		},
		params: { tenant },
	}) => {
		if (!tenant) {
			throw new Error("Tenant context is not set");
		}
		setTenant(tenant);

		// HA-746: await the app instance rather than read the router-context snapshot of it.
		const app = await queryClient
			.ensureQueryData(appInstanceApi.getOptionsCurrent(tenant))
			.then((d) => d.item)
			.catch(() => null);

		if (!app) {
			return { noLocations: false };
		}

		// HA-753: a tenant with no locations has no terminal to open.
		const venueId = firstLocationId(app);
		if (!venueId) {
			return { noLocations: true };
		}

		throw redirect({
			to: "/$tenant/venues/$venueId",
			params: {
				tenant: app.id,
				venueId,
			},
		});
	},
});

function RouteComponent() {
	const { noLocations } = Route.useRouteContext();

	return noLocations ? <NoLocations /> : <Outlet />;
}
